import { QueryEmailProviderArgs } from '../generated';
import { prepareDataForApolloCache } from '../prepareDataForApolloCache';
import { trelloFetch } from '@trello/fetch';
import type { TrelloRestResolver } from '../types';
import { isQueryInfo } from '../isQueryInfo';

export const emailProviderResolver: TrelloRestResolver<QueryEmailProviderArgs> = async (
  obj,
  args,
  context,
  info,
) => {
  const rootNode = isQueryInfo(info) ? info.field : info.fieldNodes[0];
  const email = args && args.email;

  const response = await trelloFetch(
    `/checkYourEmail?email=${email}`,
    { credentials: 'same-origin' },
    {
      clientVersion: context.clientAwareness.version,
      networkRequestEventAttributes: {
        source: 'graphql',
        resolver: 'EmailProvider',
        operationName: context.operationName,
      },
    },
  );

  const emailProvider = await response.json();

  if (emailProvider.error) {
    throw new Error(emailProvider.error);
  }

  return prepareDataForApolloCache(emailProvider, rootNode);
};
